import type { ReactNode } from "react";
import { Space, Typography } from "antd";
import { palette } from "../../theme";

/** Intestazione di pagina: titolo, eventuale breadcrumb sopra, azioni a destra. */
export function PageHead({ title, crumb, actions }: { title: ReactNode; crumb?: ReactNode; actions?: ReactNode }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 12, alignItems: "flex-end", justifyContent: "space-between", marginBottom: 16, minWidth: 0 }}>
      <div style={{ minWidth: 0, maxWidth: "100%" }}>
        {crumb && <div style={{ fontSize: 12, color: palette.muted, marginBottom: 2 }}>{crumb}</div>}
        <Typography.Title level={2} style={{ margin: 0, color: palette.heading, overflowWrap: "anywhere" }}>
          {title}
        </Typography.Title>
      </div>
      <Space wrap>{actions}</Space>
    </div>
  );
}

export function Kpi({ value, label, sub, tone, onClick }: { value: ReactNode; label: string; sub?: ReactNode; tone?: "good" | "alert"; onClick?: () => void }) {
  const border = tone === "alert" ? palette.bad : tone === "good" ? palette.ok : palette.hair;
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        textAlign: "left",
        background: palette.card,
        border: `1px solid ${border}`,
        borderRadius: 10,
        padding: "14px 16px",
        cursor: onClick ? "pointer" : "default",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        font: "inherit",
        color: "inherit",
      }}
    >
      <span style={{ fontSize: 26, fontWeight: 800, color: tone === "alert" ? palette.bad : palette.heading, lineHeight: 1.15 }}>{value}</span>
      <span style={{ fontSize: 12.5, color: palette.muted }}>{label}</span>
      {sub && <span style={{ fontSize: 12, color: palette.muted }}>{sub}</span>}
    </button>
  );
}

/** Griglia KPI: righe piene (5 colonne su desktop e tablet, 2 su telefono) invece di card orfane. CSS in theme.ts (.ap-kpi). */
export const kpiGrid: React.CSSProperties = { marginBottom: 16 };
export const kpiGridClass = "ap-kpi";
